import React from 'react'
import CardArticle from 'components/cards/cardArticle'
import TagIcon from 'components/tagIcon'
import LinkAnimate from 'utils/hooks/linkAnimate'
import { iconNews } from 'utils/icons'
import { COMMON } from 'utils/intl/common'

function SectionBlog(props) {
  let {
    data,
    className = '',
    title = COMMON.LEARN_MORE_ABOUT_QOVERY,
    tag = COMMON.RECENT_POSTS,
    tagIcon = iconNews,
    titleLeft = false,
    noSeeMore = false,
  } = props

  data = data.filter((currentData) => currentData.block?.document !== null)

  if (data.length === 0) return null

  return (
    <section className={`section ${className}`}>
      <div className="container">
        <div className="row">
          <div className="col col-lg-12 col--center">
            <div className={`${titleLeft ? 'mb-4' : 'ft-center mb-7'}`}>
              <TagIcon className={`${titleLeft ? '' : 'tag--center'}`} tag={tag} tagIcon={tagIcon} />
              <h2 className="h1 c-text-black-lighter">{title}</h2>
            </div>
            <div className="row">
              {data.map((currentData, index) => {
                return (
                  <div key={index} className={`col col-md-4 mb-3 ${data.length !== index + 1 ? 'mb-md-0' : ''}`}>
                    <CardArticle
                      slug={currentData.block ? currentData.block.uid : currentData.uid}
                      data={currentData.data ? currentData.data : currentData.block.document.data}
                    />
                  </div>
                )
              })}
            </div>
            {!noSeeMore && (
              <div className="ft-center">
                <LinkAnimate className="btn btn--secondary mt-2" to="blog">
                  {COMMON.SEE_ALL_ARTICLES}
                </LinkAnimate>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default SectionBlog
